var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-fluid",attrs:{"src":require('../assets/img/avatar.jpg'),"alt":"Full Name"}})
}
var staticRenderFns = []

export { render, staticRenderFns }